import { OnDestroy, Input, ElementRef, Renderer2, Directive } from "@angular/core";
import { Subscription } from "rxjs";
import { Record } from "@common/data-models/records/record";
import { CriteriaObj } from "@common/data-models/criteria/criteria-obj";
import { Adorner } from "@common/data-models/service/adorner";
import { TimeoutQueue } from "@common/services/timeout-queue";
import { GlobalTablesService } from "@common/services/global-tables-service";
import { EnpsDirective } from "@common/components/base/enps-directive";

@Directive({selector: "adorner"})
export class AbstractAdornerDirective extends EnpsDirective implements OnDestroy {
    protected locationID: string
    private _type: string;
    @Input('itemType') public set itemType(type: string) {
        this._type = type;
        if (this._type) {
            this.applyAdorner();
        }
    }
    public get itemType(): string {
        return this._type;
    }

    private recordChangeSub: Subscription;
    private _record: Record;
    @Input('record')
    public set record(v: Record) {
        this._record = v;
        if (this.recordChangeSub) {
            this.recordChangeSub.unsubscribe();
        }
        this.applyAdorner();
        if (this._record) {
            super.createSubscription(this._record.changeObserver, this.applyAdorner.bind(this))
        }
    }

    public get record(): Record {
        return this._record;
    }

    protected predefinedAssignmentIconsMap: { [type: string]: { icon: string, color: string } } = {
        "GRAPHIC": { icon: "icon-Graphic", color: "#f15a24" },
        "INTERACTIVE": { icon: "icon-Interactive", color: "#c1272d" },
        "AUDIO": { icon: "icon-Audio", color: "#321911" },
        "LIVEVIDEO": { icon: "icon-LiveVideo", color: "#662D91" },
        "TEXT": { icon: "icon-Text", color: "#000000" },
        "PHOTO": { icon: "icon-Photo", color: "#006837" },
        "VIDEO": { icon: "icon-Video", color: "#2e3192" },
        "SOCIALPROMOTION": { icon: "icon-SocialPromotion", color: "#0d47a1" },
        "SOCIAL": { icon: "icon-SocialPromotion", color: "#0d47a1" }
    }

    constructor(protected el: ElementRef, protected renderer: Renderer2, protected globalTablesService: GlobalTablesService, timeoutQueue: TimeoutQueue) {
        super(timeoutQueue)
    }

    protected applyAdorner() {
        let vcToApply = this.findCriteria();
        this.applyVC(vcToApply);
    }

    public findCriteria(): { visibilityCriteria: CriteriaObj, adorner: Adorner } {
        let vcs = Record.adornerVisibilityCriteriaCache[this.locationID];
        let vcToApply: { visibilityCriteria: CriteriaObj, adorner: Adorner } = null;
        if (vcs && vcs.length) {
            let rec = null;
            if (this.record) {
                rec = this.record.getRecordAsObject();
            }
            for (let vc of vcs) {
                let visible = false;
                if (vc.visibilityCriteria) {
                    try {
                        if (rec && Object.keys(rec).length > 0) {
                            visible = eval(vc.visibilityCriteria.criteria);
                        } else {
                            visible = eval(vc.visibilityCriteria.criteria);
                        }
                    } catch (e) {
                        visible = false;
                        // console.log("Visibility Criteria is not a valid expression.")
                    }
                }

                if (visible && vc && vc.adorner) {
                    vcToApply = vc;
                    break;
                }
            }

        }
        return vcToApply;
    }

    protected applyVC(vcToApply: { visibilityCriteria: CriteriaObj, adorner: Adorner }) {}
}
